import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Api } from "../api/baseApi";
import { useTranslation } from "react-i18next";

function EbookForm() {
    const { t, i18n } = useTranslation();
    const initialValues = { name: "", surname: "", email: "", phone: "" };

    const validationSchema = Yup.object({
        name: Yup.string().required(t("becomeSellerTwo.ebookModal.errors.0")),
        surname: Yup.string().required(t("becomeSellerTwo.ebookModal.errors.1")),
        email: Yup.string()
            .email(t("becomeSellerTwo.ebookModal.errors.2"))
            .required(t("becomeSellerTwo.ebookModal.errors.3")),
        phone: Yup.string()
            .matches(/^\+?\d{1,4}?[\d\s-]{5,}$/, t("becomeSellerTwo.ebookModal.errors.5"))
            .required(t("becomeSellerTwo.ebookModal.errors.4")),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            await Api.post(`/api/ebookSend`, {...values, project: 'Nomio'});


            const pdfUrl = `/assets/pdfs/e-book-nomio-${i18n.language}.pdf`;

            if (pdfUrl) {
                setTimeout(() => {
                    window.open(pdfUrl, "_blank");
                }, 1500);
            }

            resetForm();
        } catch (error) {
            console.error("Ebook send failed:", error);
        } finally {
            setSubmitting(false);
        }
    };
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting }) => (
                <Form className="row gy-4">
                    {/* Name */}
                    <div className="col-12">
                        <label className="form-label mb-2 font-18 font-heading fw-600">
                            {t("becomeSellerTwo.ebookModal.labels.0")}
                        </label>
                        <div className="position-relative">
                            <Field
                                type="text"
                                name="name"
                                className="common-input  common-input--withIcon"
                                placeholder={t("becomeSellerTwo.ebookModal.placeholders.0")}
                            />
                            <span className="input-icon">
                                <img src="/assets/images/icons/user-icon.svg" alt="" />
                            </span>
                        </div>
                        <ErrorMessage name="name" component="div" className="text-danger mt-1" />
                    </div>

                    {/* Surname */}
                    <div className="col-12">
                        <label className="form-label mb-2 font-18 font-heading fw-600">
                            {t("becomeSellerTwo.ebookModal.labels.1")}
                        </label>
                        <div className="position-relative">
                            <Field
                                type="text"
                                name="surname"
                                className="common-input  common-input--withIcon"
                                placeholder={t("becomeSellerTwo.ebookModal.placeholders.1")}
                            />
                            <span className="input-icon">
                                <img src="/assets/images/icons/user-icon.svg" alt="" />
                            </span>
                        </div>
                        <ErrorMessage name="surname" component="div" className="text-danger mt-1" />
                    </div>

                    {/* Email */}
                    <div className="col-12">
                        <label className="form-label mb-2 font-18 font-heading fw-600">
                            {t("becomeSellerTwo.ebookModal.labels.2")}
                        </label>
                        <div className="position-relative">
                            <Field
                                type="email"
                                name="email"
                                className="common-input  common-input--withIcon"
                                placeholder={t("becomeSellerTwo.ebookModal.placeholders.2")}
                            />
                            <span className="input-icon">
                                <img src="/assets/images/icons/envelope-icon.svg" alt="" />
                            </span>
                        </div>
                        <ErrorMessage name="email" component="div" className="text-danger mt-1" />
                    </div>

                    {/* Phone */}
                    <div className="col-12">
                        <label className="form-label mb-2 font-18 font-heading fw-600">
                            {t("becomeSellerTwo.ebookModal.labels.3")}
                        </label>
                        <div className="position-relative">
                            <Field
                                type="tel"
                                name="phone"
                                className="common-input  common-input--withIcon"
                                placeholder={t("becomeSellerTwo.ebookModal.placeholders.3")}
                            />
                        </div>
                        <ErrorMessage name="phone" component="div" className="text-danger mt-1" />
                    </div>

                    {/* Submit */}
                    <div className="col-12">
                        <button
                            id="ebook-form-button"
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-main btn-lg w-100 pill"
                        >
                            {t("becomeSellerTwo.ebookModal.btn")}
                            
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default EbookForm;

